<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel()">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>Specific Pieces</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
  
    <ion-list>
    <ion-item v-for="item in items" :key="item.index">
      <ion-select 
        :aria-label="item.label"
        :label="item.label"
        :value="item.count"
        justify="start"
        @ionChange="handleChange($event,item.index)"
        @ionCancel="handleCancel()"
        @ionDismiss="handleDismiss()"
      >
    
        <ion-select-option value="0">--</ion-select-option>
        <ion-select-option value="1">{{ t("One") }}</ion-select-option>
        <ion-select-option value="2">{{ t("Two") }}</ion-select-option>
        <ion-select-option value="3">{{ t("Three") }}</ion-select-option>
        <ion-select-option value="4">{{ t("Four") }}</ion-select-option>
        <ion-select-option value="5">{{ t("Five") }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>

  </ion-content>
</template>

<script  setup>
  import {
    IonList,
    IonSelect,
    IonSelectOption,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t } from "@/composables/translateText.js";

  const props = defineProps({
    optionString : {
      type : String,
      default : ""
    }
	})

  const descriptionHeading = ref(t("Select the # of Pieces You want to Track"))

  const labelStrings = [ 
    t("White") + " " + t("Bishop"), 
    t("White") + " " + t("Knight"), 
    t("White") + " " + t("Rook"), 
    t("White") + " " + t("Queen"), 
    t("Black") + " " + t("Bishop"), 
    t("Black") + " " + t("Knight"), 
    t("Black") + " " + t("Rook"), 
    t("Black") + " " + t("Queen")
  ]

  const items = ref([])
  var changesMade = false
  var originalString = ""
  
  const selectedId = ref("")

  originalString = props.optionString
  const counts = props.optionString.split("\t")
  items.value = []
  for (var i=0; i < 8; i++) {
    var one = { index : i, label : labelStrings[i], count : counts[i] }
    items.value.push(one)
  }

  function cancel() {
    modalController.dismiss(null, 'cancel');
  }

  function confirm() {
    var newValues = []
    for (var i=0; i < 8; i++)
      newValues.push(items.value[i].count)
    const newValueString = newValues.join(",")
    var result = { selected : newValueString}

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function handleChange(ev,index) {
    //console.log('ionChange fired with value: ' + ev.detail.value);
    items.value[index].count = ev.detail.value
  }
  function handleCancel() {
    //console.log('ionCancel fired');
  }
  function handleDismiss() {
    //console.log('ionDismiss fired');
  }

</script>

<style scoped>

.odd_entry {
  border-bottom : 5px;
  border-color : yellow;
  margin-top : 5px;
}
.even_entry {
  border-bottom: 1px;
  border-color : yellow;
  margin-top : 5px;
}

</style>
